import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import FilterListIcon from '@mui/icons-material/FilterList';
import AddButton from '../AddButton';

const TableToolbar = ({tableName, noFilter, onAdd}) => {
  return (
    <Toolbar sx={{pl: {sm: 2}}}>
      <Typography
        sx={{flex: '1 1 100%'}}
        variant="h6"
        id="tableTitle"
        component="div">
        {tableName}
      </Typography>
      {/* {!noFilter && (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )} */}
      {onAdd && <AddButton onClick={onAdd} sx={{marginLeft: '1rem'}} />}
    </Toolbar>
  );
};

export default TableToolbar;
